/** Marks an autocomplete holding an `endAction`, which the theme pins to the field's top-right corner. */
export const AUTOCOMPLETE_END_ACTION_CLASS = 'OmAutocomplete-endAction'

/** The end action's rendered width, which the theme reserves beside the values so they never run under it. */
export const AUTOCOMPLETE_END_ACTION_WIDTH_VAR = '--OmAutocomplete-endActionWidth'
